/*
 * @Author: cc
 * @Date: 2020-01-16 11:14:38
 * @LastEditTime : 2020-01-17 16:35:54
 * @LastEditors  : cc
 * @FilePath: \xjmediacloud\app\resourceCenter\materialResource\service\moveFile\moveFile.js
 * @Description: 移动素材到文件夹
 */
'use strict';
angular.module('commonModalWithTreeModule', []).controller('commonModalWithTreeCtrl', [
    '$scope',
    '$modalInstance',
    'tree',
    function($scope, $modalInstance, tree) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.data = {
                tree: tree.treeData, // 树结构数据
                selectedNode: {}, // 选择的节点
                expand: [], // 要展开的节点
                selectArray: [],
            };
            $scope.status = {
                treeOptions: {
                    // 结构树配置
                    nodeChildren: 'CHILDREN',
                    dirSelectable: true,
                    allowDeselect: false,
                    injectClasses: {
                        ul: 'moveDraftTree-ul',
                        li: 'moveDraftTree-li',
                        liSelected: 'a7',
                        iExpanded: 'a3',
                        iCollapsed: 'a4',
                        iLeaf: 'a5',
                        label: 'rolegrouplabselected',
                        labelSelected: 'moveDraftTree-label',
                    },
                    isLeaf: function(node) {
                        return node.relationid; // 素材库文件夹没有分类
                    },
                },
                ifExpand: true, // 是否展开全部文件
            };
        }

        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {}

        /**
         * [selectNode description] 选择节点
         * @param   {[obj]}  node  [node description] 节点信息
         * @return  {[type]}       [return description]
         */
        $scope.selectNode = function(node) {
            $scope.data.selectNode = node;
        };

        /**
         * [confirm description] 确定
         * @return {Boolean} [description]
         */
        $scope.confirm = function() {
            $modalInstance.close($scope.data.selectNode);
        };

        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
    },
]);
